import { Tile, Text, Icon, TextButton, TileControl } from "@amzn/storm-ui";
import { refresh } from "@amzn/storm-ui-icons";
import { useMountEffect } from "@react-hookz/web";
import { sampleSize } from "lodash";
import React, { useState } from "react";
import styled from "styled-components";

import { DivFlexAlignStretch } from "../../../common/styled.components";

export interface ExamplePrompt {
    label: string;
    value: string;
}

const RefreshButton = styled(TextButton)`
    margin-left: 8px;
    color: ${({ theme }) => theme.color.gray[800]};
    font-size: 14px;
`;

const TileContainer = styled.div`
    align-content: center;
    width: 25%;
`;

const StyledTile = styled(Tile)`
    div:last-child {
        overflow: auto;
        height: 70px;
    }
`;

const StyledTileControl = styled(TileControl)`
    cursor: pointer;
`;

const Container = styled.div`
    margin-top: 18px;
    padding-bottom: 20px;
`;

export const ExamplePrompts: React.FunctionComponent<{
    prompts: ExamplePrompt[];
    onClick: (value: string) => void;
}> = ({ prompts, onClick }): JSX.Element => {
    const [indices, setIndices] = useState<number[]>([]);

    const resampleIndices: () => void = () => {
        const unseenIndices = [...Array(prompts.length).keys()].filter(
            (i) => !indices.includes(i),
        );
        setIndices(sampleSize(unseenIndices, 4));
    };

    useMountEffect(() => {
        resampleIndices();
    });

    return (
        <Container>
            <div style={{ marginBottom: "10px", display: "flex" }}>
                <Text>Example prompts</Text>
                <RefreshButton
                    data-testid="refresh-examples-button"
                    onClick={() => resampleIndices()}
                >
                    <Icon type={refresh} />
                </RefreshButton>
            </div>
            <DivFlexAlignStretch>
                {indices.map((i) => {
                    const { label, value } = prompts[i];
                    return (
                        <TileContainer>
                            <StyledTile
                                key={label}
                                label={label}
                                value={value}
                                onChange={(e) => onClick(e.target.value)}
                                selected={false}
                                data-testid={`example-prompt-${i}`}
                            >
                                <StyledTileControl text={value} title={label} />
                            </StyledTile>
                        </TileContainer>
                    );
                })}
            </DivFlexAlignStretch>
        </Container>
    );
};
